<template>
    
</template>
<script>
import {
    confirmEmail
} from "@/api/tesla/emailSetting.js";
export default {
    data() {
        return {
            param:{
                detailId:this.$route.query.detailId,
                empNo:this.$route.query.empNo
            }
        }
    },
    created() {
        confirmEmail({
            param:JSON.stringify(this.param)
        }).then(res=>{
            if(res.data.code==0) {
                this.$confirm('', '邮件确认成功！', {
                    confirmButtonText: '完成',
                    showCancelButton:false,
                    type: 'success',
                    showClose:false,
                    center: true
                }).then(() => {
                    window.opener = null;
                    window.open("about:blank", "_top").close()
                })
            }
        })
    }
}
</script>